module.exports = __webpack_public_path__ + "img/lckj.024869a1.jpg";